
import {MystQuete} from './app/MystQuete.js';
window.MystQuete = MystQuete;

import {MystRemise} from './app/MystRemise.js';
window.MystRemise = MystRemise;
